import React from 'react'
import Layout from '../layouts/index.js'
import Contact from '../components/contact/contact.js'
import ImageSlider from '../components/hero/index'

function importAll(r) {
  return r.keys().map(r)
}

const images = importAll(
  require.context(
    '../images/ice-cream-page',
    false,
    /\.(png|jpe?g)$/ // png, jpg, jpeg
  )
)

class LunchTruckPage extends React.Component {
  render() {
    return (
      <Layout head={{ title: 'Ice Cream Trucks, Paleta Carts, Fruit Carts' }}>
        <section id="title">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h1 className="heading-title">
                  Ice Cream Trucks, Paleta Carts, Fruit Carts
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section
          id="ice-cream-trucks-paleta-carts-fruit-carts"
          className="text-center"
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <h1
                  className="section-title"
                  style={{ maxWidth: '800px', margin: '0 auto 40px' }}
                >
                  Ice Cream Truck & Paleta & Fruit Carts
                </h1>
                <div
                  className="mb-5 "
                  style={{ maxWidth: '800px', margin: '0 auto' }}
                >
                  <p className="section-p">
                    All ice cream trucks, paletero and fruit carts use have
                    multiple touch points.
                  </p>
                  <p className="section-p">
                    Media rate will include (10) 8” wide x 5” high mini
                    billboards placed in a visible location on the Truck or
                    Cart. Note the 8 x 5 landscape format is the standard size
                    ice cream truck menu sticker. This allows us to place your
                    ads in multiple places.
                  </p>
                  <p className="section-p">
                    Additional mini billboard stickers are given to the vendor
                    to hand out to customers.
                  </p>
                </div>
                <div className="container" style={{ maxWidth: '1800px' }}>
                  <div className="carousel-container">
                    <ImageSlider images={images} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </Layout>
    )
  }
}
export default LunchTruckPage
